import type { ReactNode } from "react";
import { cn } from "../../app/components/ui/utils";

export interface BottomActionBarProps {
  children: ReactNode;
  className?: string;
  /** When true, offsets above the app mobile bottom nav (~4rem + safe area). Default true. */
  aboveBottomNav?: boolean;
}

export function BottomActionBar({
  children,
  className,
  aboveBottomNav = true,
}: BottomActionBarProps) {
  return (
    <div
      role="toolbar"
      className={cn(
        "md:hidden fixed inset-x-0 z-50 flex flex-wrap items-center justify-center gap-2 border-t border-border bg-background/95 p-3 backdrop-blur supports-[backdrop-filter]:bg-background/85",
        aboveBottomNav
          ? "bottom-[calc(4.25rem+env(safe-area-inset-bottom,0px))]"
          : "bottom-0 pb-[max(0.75rem,env(safe-area-inset-bottom,0px))]",
        className,
      )}
    >
      {children}
    </div>
  );
}
